import { render, staticRenderFns } from "./DbDygraphs.vue?vue&type=template&id=053936cb&"
import script from "./DbDygraphs.vue?vue&type=script&lang=js&"
export * from "./DbDygraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports